import {Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {Modal} from 'presentation/components';
import {Drawer} from 'presentation/components/Drawer';
import {DuplicityBookedCard} from 'presentation/pages/private/booking/components/DuplicityBookedCard';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {FooterDrawer} from './styles';
import {AppointmentsConfirmModalProps} from './types';
import {ActionsButtons} from './components/ActionsButtons';

const {confirmAppointmentModal} = translations['pt-br'].privateFlow.myAppointments;

export function AppointmentsConfirmModal({
	open,
	subTitle,
	onClose,
	onOpen,
	handleAction,
	isSubmitting,
	isDisabled,
	appointment,
}: AppointmentsConfirmModalProps) {
	const {isMobile} = useMediaQueries();

	return (
		<Fragment>
			{isMobile ? (
				<Drawer.Root open={open} onClose={onClose} onOpen={onOpen}>
					<Drawer.Header title={confirmAppointmentModal.title} onClose={onClose} />

					<Drawer.Content
						sx={{
							gap: 2,
							alignItems: 'center',
						}}>
						<Typography variant="subtitle1">{subTitle}</Typography>
						<DuplicityBookedCard scheduledBooking={appointment} />
					</Drawer.Content>
					<FooterDrawer>
						<ActionsButtons
							isDisabled={isDisabled}
							onCancel={onClose}
							onConfirm={handleAction}
							isSubmitting={isSubmitting}
						/>
					</FooterDrawer>
				</Drawer.Root>
			) : (
				<Modal.Root
					onClose={onClose}
					open={open}
				slotProps={{
					paper: {
						sx: {
							maxWidth: 420,
							width: '100%',
						},
					},
				}}>
					<Modal.Header onClose={onClose} title={confirmAppointmentModal.title} />
					<Modal.Content sx={{margin: 'auto'}}>
						<Typography variant="subtitle1" mb={2}>
							{subTitle}
						</Typography>
						<DuplicityBookedCard scheduledBooking={appointment} />
					</Modal.Content>
					<Modal.Footer>
						<ActionsButtons
							isDisabled={isDisabled}
							onCancel={onClose}
							onConfirm={handleAction}
							isSubmitting={isSubmitting}
						/>
					</Modal.Footer>
				</Modal.Root>
			)}
		</Fragment>
	);
}
